// Laba Rugi per (cabang, partai) — rumus sama dengan halaman Rekapan Semua Partai.
export const computePartaiRecap = ({ branches, purchases, sales, expenses, defaultCost, overrideMap }) => {
  const combos = new Map();
  purchases.forEach((p) => {
    const key = `${p.branch_id}|${p.partai || ''}`;
    if (!combos.has(key)) combos.set(key, { branch_id: p.branch_id, partai: p.partai || '' });
  });

  return Array.from(combos.values()).map(({ branch_id, partai }) => {
    const pPurchases = purchases.filter(p => p.branch_id === branch_id && (p.partai || '') === partai);
    const pSales = sales.filter(s => s.branch_id === branch_id && (s.partai || '') === partai);
    const pExpenses = expenses.filter(e => e.branch_id === branch_id && (e.partai || '') === partai);

    const sumItems = (list, filterFn, field) => list.reduce((sum, p) => sum + (p.items || [])
      .filter(filterFn).reduce((s, item) => s + (item[field] || 0), 0), 0);

    const isStokAwal = (item) => item.keterangan === 'Stok Awal';
    const rpStokAwal = sumItems(pPurchases, isStokAwal, 'subtotal');
    const rpBeli = pPurchases.reduce((sum, p) => sum + (p.total_amount || 0), 0) - rpStokAwal;

    const beratJual = pSales.reduce((sum, s) => s.keterangan !== 'Stok' ? sum + (s.quantity_kg || 0) : sum, 0);
    const rpJual = pSales.reduce((sum, s) => s.keterangan !== 'Stok' ? sum + (s.total_amount || 0) : sum, 0);
    const rpStokAkhir = pSales.reduce((sum, s) => s.keterangan === 'Stok' ? sum + (s.total_amount || 0) : sum, 0);

    const biayaOP = pExpenses.reduce((sum, e) => (
      e.description && e.description.includes('Biaya Operasional - Partai') ? sum : sum + (e.amount || 0)
    ), 0);
    const costPerGr = overrideMap[branch_id] !== undefined ? overrideMap[branch_id] : defaultCost;
    const biayaPusat = beratJual * costPerGr;

    const branch = branches.find(b => b.id === branch_id);
    return {
      branch_id,
      branch_name: branch?.name || '-',
      partai,
      labaRugi: rpJual + rpStokAkhir - rpStokAwal - rpBeli - biayaOP - biayaPusat,
    };
  });
};
